import { useEffect, useState } from 'react';
import Logo from 'assets/images/dhive.png';
import CBS from 'assets/images/cbs_grey.png';

const AuthPageWrapper = ({ children }: any) => {
  const [screenHeight, setScreenHeight] = useState(`${window.innerHeight}px`);

  useEffect(() => {
    window.addEventListener('resize', () => setScreenHeight(`${window.innerHeight}px`));

    return () => {
      window.removeEventListener('resize', () => setScreenHeight(`${window.innerHeight}px`));
    };
  }, []);
  return (
    <div className='bg-gray-100 flex flex-col items-center justify-center p-4' style={{ minHeight: screenHeight }}>
      <img src={Logo} alt='d-hive-logo' className='max-h-[80px] lg:max-h-[100px] mb-8 lg:mb-10 mx-auto' />
      <div className='bg-white rounded-md p-8 shadow-md w-full md:w-[500px]'>{children}</div>
      <div className='mt-8 lg:mt-10 mx-auto flex flex-col items-center'>
        <img src={CBS} alt='cbs-logo' className='max-h-[26px]' />
        <p className='mt-2.5 body-03 text-slate-300'>Powered by Creative Business Solutions Ltd</p>
      </div>
    </div>
  );
};

export default AuthPageWrapper;
